import { theme, ThemeConfig } from 'antd'

export const themeConfig: ThemeConfig = {
  algorithm: [theme.darkAlgorithm],
  token: {
    colorPrimary: 'var(--accent-light)',
    colorPrimaryHover: 'var(--accent-light-hover)',
  },
  components: {
    Radio: {
      buttonBg: 'var(--grey-900)',
      colorBorder: 'var(--grey-600)',
      colorPrimary: 'var(--accent-light)',
      colorPrimaryHover: 'var(--accent-light)',
      borderRadius: 8,
    },
    Button: {
      primaryColor: 'var(--grey-100)',
      colorPrimary: 'var(--accent-light)',
      colorPrimaryHover: 'var(--accent-light-hover)',
      colorPrimaryActive: 'var(--accent-dark)',
      defaultHoverBorderColor: 'var(--accent-light)',
      defaultHoverColor: 'var(--accent-light)',
      defaultShadow: 'none',
      primaryShadow: 'none',
      colorLink: 'var(--accent-light)',
      colorLinkActive: 'var(--accent-dark)',
      colorLinkHover: 'var(--accent-dark)',
      colorError: 'var(--danger-light)',
      colorErrorActive: 'var(--danger-light)',
      colorErrorHover: 'var(--danger-dark)',
      lineHeight: 20,
      fontWeight: 500,
    },
    Typography: {
      titleMarginTop: 0,
      titleMarginBottom: 0,
      colorLink: 'var(--grey-300)',
      colorLinkActive: 'var(--grey-500)',
      colorLinkHover: 'var(--grey-500)',
      colorText: 'var(--grey-300)',
    },
    Modal: {
      contentBg: 'var(--grey-900)',
      footerBg: 'var(--grey-900)',
      headerBg: 'var(--grey-900)',
      borderRadiusLG: 20,
    },
    Input: {
      addonBg: 'var(--bg-transparent)',
      colorText: 'var(--grey-100)',
      colorBorder: 'var(--grey-600)',
      colorBgContainer: 'var(--grey-900)',
      hoverBg: 'var(--bg-transparent)',
      activeBg: 'var(--bg-transparent)',
      activeShadow: 'none',
      fontFamily: '"IBM Plex Sans", sans-serif',
      hoverBorderColor: 'var(--grey-500)',
      activeBorderColor: 'var(--accent-light)',
    },
    Select: {
      colorText: 'var(--grey-100)',
      colorBorder: 'var(--grey-600)',
      colorBgContainer: 'var(--grey-900)',
      fontFamily: '"IBM Plex Sans", sans-serif',
      boxShadowSecondary: 'none',
      colorPrimaryHover: 'var(--grey-600)',
      colorPrimary: 'var(--grey-600)',
      optionSelectedBg: 'var(--accent-light)',
      colorBgElevated: 'var(--grey-600)',
      colorErrorHover: 'var(--colors-error-dark)',
      optionActiveBg: 'var(--accent-light-outline-hover)',
      controlOutline: 'var(--accent-light-outline)',
      colorBgContainerDisabled: 'var(--grey-900)',
    },
    InputNumber: {
      addonBg: 'var(--bg-transparent)',
      colorText: 'var(--grey-100)',
      colorBorder: 'var(--grey-600)',
      colorBgContainer: 'var(--grey-900)',
      hoverBorderColor: 'var(--grey-600)',
      activeBorderColor: 'var(--grey-600)',
      hoverBg: 'var(--bg-transparent)',
      activeBg: 'var(--bg-transparent)',
      activeShadow: 'none',
    },
    DatePicker: {
      addonBg: 'var(--bg-transparent)',
      colorText: 'var(--grey-100)',
      colorBorder: 'var(--grey-600)',
      colorBgContainer: 'var(--grey-900)',
      hoverBg: 'var(--bg-transparent)',
      activeBg: 'var(--bg-transparent)',
      activeShadow: 'none',
      fontFamily: '"IBM Plex Sans", sans-serif',
      colorBgElevated: 'var(--bg-primary)',
      hoverBorderColor: 'var(--grey-500)',
      activeBorderColor: 'var(--accent-light)',
    },
    Layout: {
      siderBg: 'var(--transparent)',
      bodyBg: 'var(--transparent)',
    },
    Switch: {
      colorPrimary: 'var(--accent-light)',
      colorPrimaryHover: 'var(--accent-light)',
    },
    Segmented: {
      itemActiveBg: 'var(--grey-600)',
      itemColor: 'var(--grey-100)',
      itemSelectedBg: 'var(--grey-600)',
      itemHoverBg: 'var(--grey-700)',
      trackBg: 'var(--grey-800)',
      trackPadding: 4,
    },
    Form: {
      labelRequiredMarkColor: 'var(--accent-light)',
      verticalLabelPadding: '0 0 4px',
      itemMarginBottom: 0,
    },
  },
}
